import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAppContext } from "../utils/context/app-context";
import AppToast from "../components/common/Toast";
import useBrowserStorage from "../hooks/use-browser-storage";
import { useEffect } from "react";
import { UserInfo } from "../types/user.types";


const MainLayout = () => {
  const { toastInfo } = useAppContext();
  const { getItem } = useBrowserStorage();
  const navigate = useNavigate();

  useEffect(() => {
    const userInfo: UserInfo = JSON.parse(getItem('userInfo', 'local') || '{}');
    if (!userInfo.accessToken) {
      navigate('/auth');
    } else {
      navigate('/dashboard');
    }
  }, []);
  return (
    <div className="flex h-[100vh] w-[100vw]">
      <Navbar />
      <div className="grow flex p-6 overflow-auto">
        <Outlet />
      </div>
      {toastInfo?.isOpen && <AppToast />}
    </div>
  )
}

export default MainLayout;